module.exports = __webpack_public_path__ + "img/portal.3dea53a4.svg";